import { animate, group, query, style, transition, trigger } from '@angular/animations';

/**
 * These animations use APIs deprecated in Angular 20+  and official documentation and migration guides
 * for scenarios (like query/group replacements) are not yet widely available.
 * Since we are currently on v20, and have three major versions until Angular 23 (likely 1.5 - 2 years) before these APIs are removed,
 * We will maintain them until Angular 23 when they will be removed.
 * Migration to the new signal-based animation API is planned for a future update.
 */
export const overlayAnimation = trigger('overlayAnimation', [
  transition(':enter', [
    group([
      query('.menu-backdrop', [style({ opacity: 0 }), animate('250ms ease-out', style({ opacity: 1 }))]),
      query('.menu-cards-container', [
        style({ transform: 'translateY(100%)', opacity: 0 }),
        animate('250ms ease-out', style({ transform: 'translateY(0)', opacity: 1 })),
      ]),
    ]),
  ]),
  transition(':leave', [
    group([
      query('.menu-backdrop', [animate('250ms ease-in', style({ opacity: 0 }))]),
      query('.menu-cards-container', [animate('250ms ease-in', style({ transform: 'translateY(100%)', opacity: 0 }))]),
    ]),
  ]),
]);
